import React from 'react';
import {
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  SaveOutlined,
  UndoOutlined,
} from '@ant-design/icons';

interface ActionsBarProps {
  saveReport: () => void;
  resetReportObjValues: () => void;
  setExamData: (data: unknown) => void;
  examData: unknown;
  setResetActive: (active: boolean) => void;
  resetActive: boolean;
  downloadPDF: () => void;
  editMode: boolean;
  handleSwitchChange: () => void;
  handlEditReport: () => void;
  finishMode: boolean;
  ohifViewer: boolean;
  finished: boolean;
  loadingFinished: boolean;
  setReportDetails: (details: unknown) => void;
  data: unknown;
  UploadPending: boolean;
  aiAccelerate: boolean;
  reset: () => void;
}

const ActionsBar: React.FC<ActionsBarProps> = (props) => {
  const {
    downloadPDF,
    editMode,
    handleSwitchChange,
    handlEditReport,
    UploadPending,
    reset,
  } = props;

  const cancel = () => {
    reset();
    handleSwitchChange();
  };

  // Updated button styles
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem 1rem',
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s',
    border: '1px solid #A6ABC8',
    color: '#A6ABC8',
    backgroundColor: 'white',
    cursor: 'pointer',
    marginRight: '0.75rem',
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    opacity: '0.5',
    cursor: 'not-allowed',
  };

  const iconStyle = {
    marginLeft: '0.5rem',
    fontSize: '1.125rem',
  };

  return (
    <div className="flex items-center justify-between w-full px-4 py-3 border-b border-gray-200">
      <div className="flex items-center">
        {editMode ? (
          <>
            <button style={buttonStyle} onClick={handlEditReport}>
              <span>Save</span>
              <SaveOutlined style={iconStyle} />
            </button>

            <button style={buttonStyle} onClick={cancel}>
              <span>Cancel</span>
              <CloseOutlined style={iconStyle} />
            </button>

            <button style={buttonStyle} onClick={reset}>
              <span>Reset</span>
              <UndoOutlined style={iconStyle} />
            </button>
          </>
        ) : (
          <button style={buttonStyle} onClick={handleSwitchChange}>
            <span>Edit</span>
            <EditOutlined style={iconStyle} />
          </button>
        )}
      </div>

      <div>
        <button
          style={UploadPending ? disabledButtonStyle : buttonStyle}
          onClick={downloadPDF}
          disabled={UploadPending}
        >
          <span>Download PDF</span>
          <DownloadOutlined style={iconStyle} />
        </button>
      </div>
    </div>
  );
};

export default ActionsBar;
